<template>
  <s-select
    value-field="key"
    text-field="label"
    data-test="language-select"
    :value="value"
    :options="languages"
    @input="changeValue"
  />
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'languages',
    ]),
  },
  props: {
    value: null,
  },
  methods: {
    changeValue(newVal) {
      this.$emit('input', newVal);
    },
  },
};
</script>
